import { useCallback, useEffect, useRef, startTransition } from "react";

const isStreamingDelta = (data) => {
  if (data.type === "StreamingMsgtoHuman") {
    return data.isStreamingDone !== "true";
  }

  if (data.is_streaming_chunk === true) {
    return true;
  }

  // CC 还会发送 partial assistant 快照、工具进度等高频中间事件；仅 result
  // 表示本轮完成，应保留一次进度条提示。
  return data.type === "cc_ndjson_stream" &&
    !(typeof data.ndjson === "string" && /"type"\s*:\s*"result"/.test(data.ndjson));
};

const useWsMessageDispatcher = ({
  handleWsCommonMessage,
  handleWsTaskSelection,
  handleWsExpertDialogUpdate,
  handleWsCCMessage,
  handleWsArchiveMessage,
  handleWsEditorEvents,
  handleWsRoleStatus,
  handleWsMessageHandlers,
  handleWsGameProfileUpdate,
  handleWsTodayYouCard,
  handleWsActionAnswer,
  handleWsPostMessageEffects,
  setShouldFlash,
}) => {
  const flashTimerRef = useRef(null);

  useEffect(() => () => {
    if (flashTimerRef.current) {
      clearTimeout(flashTimerRef.current);
    }
  }, []);

  return useCallback((data) => {
    if (handleWsCommonMessage(data)) return true;

    // 流式片段高频到达时，进度条持续闪烁即可；逐条创建状态更新和定时器会
    // 放大恢复大存档后的渲染负担。流式完成消息仍会触发一次正常提示。
    if (!isStreamingDelta(data)) {
      startTransition(() => {
        setShouldFlash(true);
      });

      if (flashTimerRef.current) {
        clearTimeout(flashTimerRef.current);
      }
      flashTimerRef.current = setTimeout(() => {
        startTransition(() => {
          setShouldFlash(false);
        });
        flashTimerRef.current = null;
      }, 3000);
    }

    if (handleWsTaskSelection(data)) return true;
    if (handleWsExpertDialogUpdate(data)) return true;
    if (handleWsCCMessage(data)) return true;
    if (handleWsArchiveMessage(data)) return true;
    if (handleWsEditorEvents(data)) return true;
    if (handleWsRoleStatus(data)) return true;
    if (handleWsMessageHandlers(data)) return true;
    if (handleWsGameProfileUpdate(data)) return true;
    if (handleWsTodayYouCard && handleWsTodayYouCard(data)) return true;
    if (handleWsActionAnswer(data)) return true;

    handleWsPostMessageEffects(data);
    return false;
  }, [
    handleWsActionAnswer,
    handleWsArchiveMessage,
    handleWsCCMessage,
    handleWsCommonMessage,
    handleWsEditorEvents,
    handleWsExpertDialogUpdate,
    handleWsGameProfileUpdate,
    handleWsTodayYouCard,
    handleWsMessageHandlers,
    handleWsPostMessageEffects,
    handleWsRoleStatus,
    handleWsTaskSelection,
    setShouldFlash,
  ]);
};

export default useWsMessageDispatcher;
